import { formatDate } from 'date-fns'
import { FC } from 'react'
import { StyledUpdatedText } from './styled'

interface UpdatedTextProps {
    updatedAt?: string
    updatedBy?: string
}

const UpdatedText: FC<UpdatedTextProps> = ({ updatedAt, updatedBy }) => {
    const updatedByText = updatedBy?.trim()
    if (updatedAt && updatedByText)
        return (
            <StyledUpdatedText title="Last Updated">
                {`${formatDate(updatedAt, 'MM/dd/yyyy h:mm a')} • ${updatedByText}`}
            </StyledUpdatedText>
        )
    if (updatedAt && !updatedByText)
        return (
            <StyledUpdatedText title="Last Updated">
                {formatDate(updatedAt, 'MM/dd/yyyy h:mm a')}
            </StyledUpdatedText>
        )
    if (!updatedAt && updatedByText)
        return (
            <StyledUpdatedText title="Last Updated">
                {updatedByText}
            </StyledUpdatedText>
        )
    return null
}

export default UpdatedText
